import React from 'react';
import styled from 'styled-components';
import unitValue from '../../../util/unitValue';

const Input = styled.input`
    flex-grow: 1;
    padding: 10px;
    border-radius: 5px;
    -webkit-appearance: none;
    border: 1px solid ${({ theme }) => theme.inputBorder};

    &:focus {
        outline: none;
    }

    /* For webkit browsers */
    &::-webkit-slider-runnable-track {
        width: 100%;
        height: 5.1px;
        cursor: pointer;
        border-radius: 2.5px;
        background: ${({ theme }) => theme.inputBorder};
    }

    &::-webkit-slider-thumb {
        width: 16px;
        height: 16.4px;
        cursor: pointer;
        margin-top: -6px;
        border-radius: 16.4px;
        -webkit-appearance: none;
        background: ${({ theme }) => theme.primary.bg};
        border: 3px solid ${({ theme }) => theme.primary.fg};
    }

    &:focus::-webkit-slider-runnable-track {
        /* // background: #367ebd; */
    }

    /* For firefox */
    &::-moz-range-track {
        width: 100%;
        height: 5.1px;
        cursor: pointer;
        border-radius: 2.5px;
        background: ${({ theme }) => theme.inputBorder};
    }

    &::-moz-range-thumb {
        width: 16px;
        height: 16.4px;
        cursor: pointer;
        margin-top: -6px;
        border-radius: 16.4px;
        -webkit-appearance: none;
        background: ${({ theme }) => theme.primary.bg};
        border: 3px solid ${({ theme }) => theme.primary.fg};
    }

    /* For IE */
    &::-ms-track {
        width: 100%;
        height: 5.1px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }
    &::-ms-fill-lower {
        background: #2a6495;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
    }
    &::-ms-fill-upper {
        background: #3071a9;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
    }
    &::-ms-thumb {
        width: 16px;
        height: 16.4px;
        cursor: pointer;
        margin-top: -6px;
        border-radius: 16.4px;
        -webkit-appearance: none;
        background: ${({ theme }) => theme.primary.bg};
        border: 3px solid ${({ theme }) => theme.primary.fg};
    }
    &:focus::-ms-fill-lower {
        background: #3071a9;
    }
    &:focus::-ms-fill-upper {
        background: #367ebd;
    }
`;

const RangeSlider = ({
    value,
    onChange,
    defaultUnit,
    allowedUnits,
    ...restOfProps
}) => {
    const [val] = unitValue(value);
    const unit = allowedUnits
        ? allowedUnits[0]
        : defaultUnit
        ? defaultUnit
        : '';

    const handleChange = event => {
        const { name, value } = event.target;
        onChange({ name, value: value + unit });
    };
    return (
        <Input
            {...restOfProps}
            value={val}
            type="range"
            onChange={handleChange}
        />
    );
};
export default React.memo(RangeSlider);
